// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CardPosIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CardPos/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.333 17.708a.63.63 0 0 1-.625.625H2.292a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h15.416a.63.63 0 0 1 .625.625ZM12.825 3.767l-8.95 8.95a.86.86 0 0 1-1.225 0h-.008a2.983 2.983 0 0 1 0-4.209L8.6 2.55a2.978 2.978 0 0 1 4.217 0 .858.858 0 0 1 .008 1.217Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m17.35 7.075-2.542-2.542a.86.86 0 0 0-1.225 0l-8.95 8.95a.86.86 0 0 0 0 1.225l2.542 2.55a2.993 2.993 0 0 0 4.217 0l5.95-5.958a2.965 2.965 0 0 0 .008-4.225ZM10.633 14.6l-1.008 1.017a.548.548 0 0 1-.767 0 .548.548 0 0 1 0-.767l1.017-1.017c.2-.2.55-.2.758 0a.548.548 0 0 1 0 .767Zm3.309-3.308-2.034 2.041c-.208.2-.55.2-.766 0a.548.548 0 0 1 0-.766l2.041-2.042c.2-.2.55-.2.759 0a.548.548 0 0 1 0 .767Z"
}));
export default CardPosIcon;